import { useState } from "react";
import ViewAdminsComponent from "./ViewAdminsComponent";

const AllAdminsComponent = ({ setShowNav, link }) => {
  const [inputValue, setInputValue] = useState(null);
  const [myPassword, setMyPassword] = useState(null);
  let password = "9871599433";
  return (
    <div>
      {myPassword === password ? (
        <ViewAdminsComponent link={link} />
      ) : (
        <div className="admin-auth">
          <div className="admin-auth-main">
            <div className="admin-auth-heading">Add credentials to access</div>
            <div className="admin-auth-form">
              <input
                type="password"
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="enter password"
              />
              <i
                onClick={() => setMyPassword(inputValue)}
                className="fa-solid fa-angle-right"
              ></i>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllAdminsComponent;
